import React, { useState, useCallback } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import './Faq.scss';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';

const Faq = ({ faqData }) => {
  const [activeKey, setActiveKey] = useState(null);

  const formatField = (field) => {
    if (!field || !field.value) return field;

    return {
      ...field,
      value: field.value.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>'),
    };
  };

  // DataLayer push function
  const pushToDataLayer = useCallback((eventData) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      ...eventData,
      BrandName: 'Corp Web',
      VariantName: 'NA',
    });
  }, []);

  // Handle FAQ accordion toggle - ONLY use onSelect, remove onClick
  const handleAccordionSelect = useCallback(
    (eventKey) => {
      // eventKey will be null when closing, or the key when opening
      const isExpanding = eventKey !== null;

      // Get FAQ title
      const index = eventKey ? parseInt(eventKey) : parseInt(activeKey);
      const faq = faqData?.FaqAccordianList?.[index];
      const faqTitle = faq?.fields?.FaqHeading?.value || `FAQ ${index + 1}`;

      // Track FAQ interaction using NEW schema
      pushToDataLayer({
        event: 'Faq_Interaction',
        eventCategory: 'Faq Interaction',
        eventAction: isExpanding ? 'Expand' : 'Collapse',
        eventLabel: faqTitle,
      });

      setActiveKey(eventKey);
    },
    [activeKey, faqData, pushToDataLayer]
  );

  return (
    <div className="wrapperCol faqWrap faqTru4oilPage">
      <div className="pageHead d-flex">
        <Text field={faqData?.FaqHeading} tag="h2" />
      </div>

      <RichText field={formatField(faqData?.FaqDescription)} className="titleTxt headingSubText" />

      <Accordion activeKey={activeKey} onSelect={handleAccordionSelect}>
        {faqData?.FaqAccordianList?.map((faq, index) => {
          const eventKey = String(index);

          return (
            <Accordion.Item key={index} eventKey={eventKey}>
              <Accordion.Header>
                <Text field={faq?.fields?.FaqHeading} />
              </Accordion.Header>

              <Accordion.Body>
                <RichText field={formatField(faq?.fields?.FaqDescription)} className="subtext" />
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </div>
  );
};

export default Faq;
